/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useState } from "react";
import { isWidthAndHeightValid } from "../../ArtworkMultiSize/utils";
import ErrorTypes from "../../error-types";

const noop = () => {};

// @ts-expect-error TS(7006): Parameter 'message' implicitly has an 'any' type.
const createError = (message, type) => ({
  message,
  type
});

// eslint-disable-next-line max-lines-per-function
export default function useArtworkValidation({
  minWidth = 0,
  minHeight = 0,
  maxWidth = 100,
  maxHeight = 100,
  isPrintAsIs = false,
  metadata = null,
  originalDimensions = {},
  onValidation = noop
} = {}) {
  const [errors, setErrors] = useState({});
  const [currentItem, setCurrentItem] = useState(null);
  const [originalArtworkDimensions] = useState(originalDimensions);

  function validationErrorType(id: any) {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return errors[id]?.type;
  }

  function handleValidationError(id: any, type: any, message: any) {
    // @ts-expect-error TS(2339): Property 'hasImage' does not exist on type 'never'... Remove this comment to see the full error message
    if (validationErrorType(id) !== type && currentItem?.hasImage) {
      // @ts-expect-error TS(2554): Expected 0 arguments, but got 3.
      onValidation("image_validation_error", type, {});
    }
    return createError(message, type);
  }

  function widthConstraint() {
    // @ts-expect-error TS(2339): Property 'aspectRatio' does not exist on type 'nev... Remove this comment to see the full error message
    return metadata?.aspectRatio > 1 ? metadata.maxSheetHeight : metadata.maxSheetWidth;
  }

  function heightConstraint() {
    // @ts-expect-error TS(2339): Property 'aspectRatio' does not exist on type 'nev... Remove this comment to see the full error message
    return metadata?.aspectRatio > 1 ? metadata.maxSheetWidth : metadata.maxSheetHeight;
  }

  function fitsGangSheet({ width, height }: any) {
    return (
      width !== "" &&
      height !== "" &&
      // @ts-expect-error TS(2339): Property 'maxSheetWidth' does not exist on type 'n... Remove this comment to see the full error message
      Math.min(width, height) <= metadata?.maxSheetWidth &&
      // @ts-expect-error TS(2339): Property 'maxSheetHeight' does not exist on type '... Remove this comment to see the full error message
      Math.max(width, height) <= metadata?.maxSheetHeight
    );
  }

  function invalidWidthValidation(item: any, errorsMap: any) {
    if (item.width === "") {
      errorsMap[item.id] = handleValidationError(
        item.id,
        ErrorTypes.INVALID_WIDTH,
        "Please enter a valid width."
      );
      return true;
    }
    return false;
  }

  function invalidHeightValidation(item: any, errorsMap: any) {
    if (item.height === "") {
      errorsMap[item.id] = handleValidationError(
        item.id,
        ErrorTypes.INVALID_HEIGHT,
        `Please enter a valid ${isPrintAsIs ? "length" : "height"}.`
      );
      return true;
    }
    return false;
  }

  function negativeValuesValidation(item: any, errorsMap: any) {
    if (item.width < 0 || item.height < 0) {
      errorsMap[item.id] = handleValidationError(
        item.id,
        ErrorTypes.NEGATIVE_VALUES,
        "Negative values are not permitted."
      );
      return true;
    }
    return false;
  }

  function minPrintSizeValidation(item: any, errorsMap: any) {
    if (!(item.width >= minWidth && item.height >= minHeight)) {
      errorsMap[item.id] = handleValidationError(
        item.id,
        ErrorTypes.MIN_PRINT_SIZE,
        `The minimum print size is ${minWidth}" x ${minHeight}${isPrintAsIs ? "'" : '"'}`
      );
      return true;
    }
    return false;
  }

  function maxPrintSizeValidation(item: any, errorsMap: any) {
    if (
      !isPrintAsIs &&
      !fitsGangSheet(item) &&
      !(Number(item.width) <= maxWidth && Number(item.height) <= maxHeight)
    ) {
      errorsMap[item.id] = handleValidationError(
        item.id,
        ErrorTypes.MAX_PRINT_SIZE,
        `The maximum print size is ${maxWidth}" x ${maxHeight}"`
      );
      return true;
    }
    return false;
  }

  function maxPrintSizePrintAsIsValidation(item: any, errorsMap: any) {
    // @ts-expect-error TS(2339): Property 'maxSheetHeight' does not exist on type '... Remove this comment to see the full error message
    if (isPrintAsIs && item.height > (metadata?.maxSheetHeight || maxHeight)) {
      errorsMap[item.id] = handleValidationError(
        item.id,
        // @ts-expect-error TS(2339): Property 'MAX_PRINT_SIZE_PRINT_AS_IS' does not exi... Remove this comment to see the full error message
        ErrorTypes.MAX_PRINT_SIZE_PRINT_AS_IS,
        `The maximum print size is ${minWidth}" x ${maxHeight}'`
      );
      return true;
    }
    return false;
  }

  function willFitGangSheet(item: any, errorsMap: any) {
    if (!metadata) return false;
    const isWidthValid = fitsGangSheet(item)
      ? isWidthAndHeightValid(item)
      : item.width !== "" && item.width <= widthConstraint();
    const isHeightValid = fitsGangSheet(item)
      ? isWidthAndHeightValid(item)
      : item.height !== "" && item.height <= heightConstraint();

    if (isWidthValid && isHeightValid) return false;

    errorsMap[item.id] = errorsMap[item.id]
      ? { ...errorsMap[item.id], isFieldValid: isWidthValid && isHeightValid }
      : { isFieldValid: isWidthValid && isHeightValid };

    return true;
  }

  function resetErrors() {
    setErrors({});
  }

  function validateDimensions(item: any) {
    const newErrors = {};

    const hasError = [
      invalidWidthValidation,
      invalidHeightValidation,
      negativeValuesValidation,
      maxPrintSizePrintAsIsValidation,
      minPrintSizeValidation,
      maxPrintSizeValidation
    ].some(validation => validation(item, newErrors));

    if (!hasError) {
      willFitGangSheet(item, newErrors);
    }

    setCurrentItem(item);
    setErrors(newErrors);

    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return newErrors[item.id];
  }

  return {
    errors,
    currentItem,
    originalArtworkDimensions,
    validateDimensions,
    resetErrors
  };
}
